import React from 'react';
import styled from 'styled-components';

import { Text, theme } from '../../components';
import StopThumbnail from '../../Router/pages/TourEditPage/TourSideNav/StopThumbnail';

type TourItemContainerProps = {
  locationName?: string;
  address?: string;
};

const TourItemContainer: React.FC<TourItemContainerProps> = ({
  locationName,
  address,
}) => (
  <StyledTourItemContainer>
    <ThumbnailContainer>
      <StopThumbnail />
    </ThumbnailContainer>
    <StyledAddressLocation>
      {locationName?.length >= 0 && <Text block>{locationName}</Text>}
      {address?.length >= 0 && <StyledAddress>{address}</StyledAddress>}
    </StyledAddressLocation>
  </StyledTourItemContainer>
);

export default TourItemContainer;

const StyledTourItemContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const StyledAddress = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: normal;
  line-height: 20px;
  color: ${theme.gray8};
`;

const ThumbnailContainer = styled.div`
  margin-right: 15px;
`;

const StyledAddressLocation = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;

  ${Text}:first-child {
    font-weight: 500;
  }
`;
